module.exports = __webpack_public_path__ + "img/btn_patient.dd98697f.svg";